import { render, staticRenderFns } from "./AppExpand.vue?vue&type=template&id=11b915f5&"
import script from "./AppExpand.vue?vue&type=script&lang=js&"
export * from "./AppExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports